import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quick-sidebar',
  templateUrl: './quick-sidebar.component.html',
  styles: []
})
export class QuickSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
